import React, { createContext, useContext, useState, useEffect } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import firebase from "./config";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [session, setSession] = useState({ user: null, loading: true });

  useEffect(() => {
    const auth = getAuth(firebase);
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        const userEmail = user.email;
        const isBmspuneUser = userEmail.split("@")[1] === "bmspune.org";

        isBmspuneUser
          ? setSession({ user: user, loading: false })
          : setSession({ user: null, loading: false });
      } else {
        setSession({ user: null, loading: false });
      }
    });

    return () => unsubscribe();
  }, []);

  return (
    <UserContext.Provider value={session}>{children}</UserContext.Provider>
  );
};

export const useSession = () => {
  return useContext(UserContext);
};
